import styled from 'styled-components';

export const DashboardContainer = styled.div`
  width: 100%;
  height: calc(100vh - 100px); /* Ajustando para considerar o header */
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 20px;

  .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 2;
  }
`;

export const ErrorContainer = styled.div`
  padding: 20px;
  width: 100%;
  max-width: 800px;
  margin: 40px auto;

  .ant-alert {
    border-radius: 8px;
  }

  button {
    margin-top: 16px;
  }
`;

export const IframeContainer = styled.div<{
  $isLoading: boolean;
  $hasError?: boolean;
}>`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  opacity: ${({ $isLoading, $hasError }) =>
    $isLoading || $hasError ? '0.3' : '1'};
  transition: opacity 0.3s ease-in-out;
  display: ${({ $hasError }) => ($hasError ? 'none' : 'block')};
`;
